import api from '@pray/shared/utils/api';
import type { ApiSourceType, CatalogStatus } from './types';
type Props = {
  artistId: string; catalogId: string;
  name?: string; description?: string; status?: CatalogStatus; sourceType?: ApiSourceType;
};
export async function patchCatalog({ artistId, catalogId, name, description, status, sourceType }: Props) {
  if (!artistId) throw new Error('Artist ID is required');
  const body: Record<string, unknown> = {};
  if (name !== undefined) body.name = name;
  if (description !== undefined) body.description = description;
  if (status !== undefined) body.status = status;
  if (sourceType !== undefined) body.source_type = sourceType;
  // Backend returns only { success: true }, not a catalog — callers refetch.
  // Unwrap the envelope one level — see getCatalogs.ts.
  const res = await api.executePatchRequest<{ data: { success: true } }>(
    `/web/studio/artists/${artistId}/catalogs/${catalogId}`, body);
  return res.data.data;
}
